<!--
 * @Author: your name
 * @Date: 2020-09-22 15:14:06
 * @LastEditTime: 2021-03-24 07:44:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/DownLoadTax/index.vue
-->
<style scoped lang="sass">
.download_tax
  padding-left: 17px
  padding-right: 17px

  .title
    font-size: 12px
    line-height: 16px
    margin-bottom: 10px
    color: var(--menu-primary-text-colour) !important

  .down
    line-height: 12px
    font-size: 12px
    text-decoration-line: underline
    color: var(--menu-primary-background-colour) !important
</style>

<template lang="pug">
.download_tax(v-if="!isCounterPay")
  .title.o(v-if="!isPostPaid && !isOnline") {{ tParams('receipt_sent_to', 'Your receipt has been sent to {email}.', { email: email }) }}
  .down.b
    span.p(@click="downLoadTax") {{ t('download_tax_invoice', 'Download tax invoice') }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getInvoice } from 'api/product'
import { saveAs } from 'file-saver'
import { t, tParams } from '@/utils/language'

@Component({
  props: {
    orderId: {
      type: [String, Number]
    },
    isPostPaid: {
      type: Boolean
    },
    email: {
      type: String
    },
    name: {
      type: String
    },
    isCounterPay: {
      type: Boolean
    },
    isOnline: {
      type: Boolean
    },
    isSubGroup: {
      type: Boolean,
      default: false
    }
  }

})
class DownLoadTax extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) {
    return tParams(key, fallback, params)
  }

  downLoadTax() {
    const type = this.isSubGroup ? 'subGroup' : ''
    getInvoice({
      id: this.orderId,
      output: 'pdf',
      user_id: localStorage.getItem('userId') || ''
    }, type
    ).then(res => {
      saveAs(res, `${this.name}.pdf`)
    })
  }
}

export default DownLoadTax
</script>
